/*=========================================================================================
File Name: router.js
Description: Routes for vue-router. Lazy loading is enabled.
----------------------------------------------------------------------------------------
Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
Author: Pixinvent
Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


import Vue from 'vue'
import store from './store/store.js';
import Router from 'vue-router'

Vue.use(Router);

// =============================================================================
// AUTH CHECK
// =============================================================================
function requireAuth(to, from, next) {
	/*
		Auth Check AXIOS call
	*/
	router.app.$axiosSecure.get(`/auth-check`)
		.then((response) => {
			if (response) {
				// Proceed to route
				next();
			}
			else {
				// Redirect to login
				next('/pages/login');
			}
		})
		.catch(error  => {
			// If user is not logged in
			if (error.response && error.response.status == 403) {
				// Clear user details
				store.dispatch('auth/clearAuthenticatedUser');
				// Redirect to login
				next('/pages/login');
			}
			else {
				router.app.$vs.notify({
					color: 'danger',
					title: 'Something went wrong',
					text: 'Please contact the server admin'
				});
			}
			// eslint-disable-next-line no-console
			console.log(error);
		})
}
// =============================================================================

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	scrollBehavior () {
		return { x: 0, y: 0 }
	},
	routes: [
		
		{
			// =============================================================================
			// MAIN LAYOUT ROUTES
			// =============================================================================
			path: '',
			component: () => import('./layouts/main/Main.vue'),
			children: [
				// =============================================================================
				// Theme Routes
				// =============================================================================
				// NOTE: Commented for MVP
				// {
				// 	path: '/',
				// 	name: 'home',
				// 	component: () => import('./views/Dashboard.vue'),
				// 	beforeEnter: requireAuth,
				// },
				// NOTE: Made default for MVP
				{
					path: '/',
					redirect: {
						name: 'search-logs'
					}
				},
				{
					path: '/access-control/users',
					name: 'access-control.users',
					component: () => import('./views/modules/access-control/users/UserList.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'ACL',
								active: false
							},
							{
								title: 'Users',
								active: true
							}
						],
						buttons: {
							refresh: true
						},
						pageTitle: 'ACL'
					}
				},
				{
					path: '/access-control/roles',
					name: 'access-control.roles',
					component: () => import('./views/modules/access-control/roles/RoleList.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'ACL',
								active: false
							},
							{
								title: 'Roles',
								active: true
							}
						],
						buttons: {
							refresh: true,
							add: true
						},
						pageTitle: 'Roles',
					}
				},
				{
					path: '/search-logs',
					name: 'search-logs',
					component: () => import('./views/modules/search-logs/SearchLogs.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'Search Logs',
								active: false
							},
							{
								title: 'List',
								active: true
							},
						],
						buttons: {
							refresh: true,
							download: true
						},
						pageTitle: 'Search Logs',
						syncCNIC: true
					}
				},
				{
					path: '/godaddy-logs',
					name: 'godaddy-logs',
					component: () => import('./views/modules/godaddy-logs/GoDaddyLogs.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'GoDaddy Logs',
								active: false
							},
							{
								title: 'List',
								active: true
							},
						],
						buttons: {
							refresh: true,
							download: true
						},
						pageTitle: 'GoDaddy Logs',
						syncCNIC: true
					}
				},
				{
					path: '/parent-categories',
					name: 'parent-categories',
					component: () => import('./views/modules/parent-categories/ParentCategories.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'Parent Categories',
								active: false
							},
							{
								title: 'List',
								active: true
							}
						],
						buttons: {
							refresh: true,
							add: true
						},
						pageTitle: 'Parent Categories',
					}
				},
				{
					path: '/categories',
					name: 'categories',
					component: () => import('./views/modules/categories/Categories.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'Categories',
								active: false
							},
							{
								title: 'List',
								active: true
							}
						],
						buttons: {
							refresh: true,
							add: true
						},
						pageTitle: 'Categories',
					}
				},
				{
					path: '/keywords',
					name: 'keywords',
					component: () => import('./views/modules/keywords/Keywords.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'Keywords',
								active: false
							},
							{
								title: 'List',
								active: true
							}
						],
						buttons: {
							refresh: true,
							add: true
						},
						pageTitle: 'Keywords',
					}
				},
				{
					path: '/prefixes',
					name: 'prefixes',
					component: () => import('./views/modules/prefixes/Prefixes.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'Prefixes',
								active: false
							},
							{
								title: 'List',
								active: true
							}
						],
						buttons: {
							refresh: true,
							add: true
						},
						pageTitle: 'Prefixes',
					}
				},
				{
					path: '/suffixes',
					name: 'suffixes',
					component: () => import('./views/modules/suffixes/Suffixes.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'Suffixes',
								active: false
							},
							{
								title: 'List',
								active: true
							}
						],
						buttons: {
							refresh: true,
							add: true
						},
						pageTitle: 'Suffixes',
					}
				},
				{
					path: '/curated-names',
					name: 'curated-names',
					component: () => import('./views/modules/curated-names/CuratedNames.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'Curated Names',
								active: false
							},
							{
								title: 'List',
								active: true
							}
						],
						buttons: {
							refresh: true,
							add: true
						},
						pageTitle: 'Curated Names',
					}
				},
				{
					path: '/seo-pages/pages',
					name: 'seo-pages.pages',
					component: () => import('./views/modules/seo-pages/pages/PageList.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'SEO Pages',
								active: false
							},
							{
								title: 'Page List',
								active: true
							}
						],
						buttons: {
							refresh: true,
							add: true
						},
						pageTitle: 'Page List',
					}
				},
				{
					path: '/seo-pages/tags',
					name: 'seo-pages.tags',
					component: () => import('./views/modules/seo-pages/tags/TaggedNames.vue'),
					beforeEnter: requireAuth,
					meta: {
						breadcrumb: [
							{
								title: 'Home',
								url: '/'
							},
							{
								title: 'SEO Pages',
								active: false
							},
							{
								title: 'Tagged Names',
								active: true
							}
						],
						buttons: {
							refresh: true,
							add: true
						},
						pageTitle: 'Tagged Names',
					}
				},
			],
		},
		// =============================================================================
		// FULL PAGE LAYOUTS
		// =============================================================================
		{
			path: '',
			component: () => import('@/layouts/full-page/FullPage.vue'),
			children: [
				// =============================================================================
				// PAGES
				// =============================================================================
				{
					path: '/pages/login',
					name: 'page-login',
					component: () => import('@/views/pages/Login.vue')
				},
				{
					path: '/pages/not-authorized',
					name: 'page-not-authorized',
					component: () => import('@/views/pages/NotAuthorized.vue')
				},
				{
					path: '/pages/error-404',
					name: 'page-error-404',
					component: () => import('@/views/pages/Error404.vue')
				},
			]
		},
		// Redirect to 404 page, if no match found
		{
			path: '*',
			redirect: '/pages/error-404'
		}
	],
})

router.afterEach(() => {
	// Remove initial loading
	const appLoading = document.getElementById('loading-bg')
	if (appLoading) {
		appLoading.style.display = "none";
	}
	// Remove tooltips
	const Stickedtooltips = document.querySelectorAll(".vs-tooltip");
	for (const tooltip of Stickedtooltips) {
		tooltip.remove();
	}
})

export default router
